

export default class TableScrollManager {

  constructor(params = {}) {
    this.offset = params.offset ? params.offset : 30
    this.scrollCB = params.callback
    this.toBottom = params.toBottom ? params.toBottom : () => {}
    this.toTop = params.toTop ? params.toTop : () => {}
    this.eventCount = 0
    this.scrollTimer = null
    this.scrollCB = this.initScrollCB()
    //要求ableClass 应包含通过Math.random() 转字符串的 形式
    this.className = params.class
    this.wrap = null
    this.list = null
  }
  bindDoms() {
    this.wrap = document.getElementsByClassName(this.className)[0].getElementsByClassName('el-table__body-wrapper')[0]
    this.list = this.wrap.getElementsByClassName('el-table__body')[0]
  }
  rollback(unitCount) {
    if(this.getOptions().length) {
      let scrollTop = this.wrap.scrollTop + unitCount * this.getOptions()[0].offsetHeight
      scrollTop < 0 && (scrollTop = 0)
      this.wrap.scrollTop = scrollTop
    }
  }
  getScrollTop() {
    return this.wrap.scrollTop
  }
  scrollTo(height) {
    this.wrap && (this.wrap.scrollTop = height)
  }
  getOptions() {
    return this.list.getElementsByTagName('tr')
  }

  initScrollCB() {
    return () => {
      clearTimeout(this.scrollTimer)
      
      this.scrollTimer = setTimeout(() => {
        if(this.wrap.scrollTop + this.wrap.offsetHeight > this.list.offsetHeight - this.offset) {
          this.toBottom(1)
        }
        if(this.wrap.scrollTop < this.offset) {
          this.toTop(0)
        }
      }, 250)
    }
  }
  setScrollEvent() {
    if(this.eventCount === 1) return  console.error("当前存在已绑定的事件，请先解绑")
    this.wrap.addEventListener('scroll',this.scrollCB)
    this.eventCount = 1
  }
  removeScrollEvent() {
    if(this.eventCount === 0) return console.error('不存在绑定的滚动事件')
    this.wrap.removeEventListener('scroll',this.scrollCB)
    this.eventCount = 0
    console.log('remove')
  }
}





// WEBPACK FOOTER //
// ./src/util/TableScrollManager.js